// Mock data for Medics on Mission website

export const mockData = {
  hero: {
    tagline: "Saving Lives, One Mission at a Time",
    description: "Providing medical outreach, free clinics, and supplies to underserved communities worldwide.",
    stats: [
      { value: "650+", label: "Patients Treated" },
      { value: "5", label: "Missions Completed" },
      { value: "100%", label: "Donations to Missions" }
    ]
  },
  
  about: {
    mission: "Medics on Mission is a non-profit organization founded by doctors based in Munich and Lebanon. Our goal is to provide medical outreach, free clinics, and supplies to underserved communities.",
    vision: "No one should be denied medical care because of where they live or what they can afford.",
    story: "Medics on Mission was founded by a young doctor who witnessed firsthand the deep inequalities of this world.\n\nDuring medical training and work in different hospitals, it became clear that access to healthcare is not a privilege — it's a right. Yet, in many villages and remote areas, people live and die without ever seeing a doctor. Treatable infections become life-threatening, children grow up without basic medical care, and families lose loved ones to conditions that could have been prevented.\n\nMedics on Mission was born from the belief that a small medical intervention can bring enormous relief. A single consultation, a simple surgery, a course of antibiotics — these can change the course of a life.\n\nOur mission is to bring doctors, treatments, and hope directly to the people who need them most. Be part of the cause — together, we can make sure no one is forgotten.",
    founder: {
      name: "Dr. Fayez El Hachem",
      role: "Founder",
      location: "Munich, Germany",
      bio: "Medical resident based in Munich with a passion for global health equity. Founded Medics on Mission to bridge the healthcare gap in underserved communities."
    }
  },
  
  projects: [
    {
      id: 1,
      title: "Batroun Mission",
      location: "Batroun, North Governorate, Lebanon",
      date: "2024",
      description: "Provided free medical consultations and distributed essential medicines to the community in Batroun.",
      impact: "100+ patients treated",
      status: "completed",
      thumbnail: "/images/Batroun Mission/batroun_1.jpg",
      gallery: [
        "/images/Batroun Mission/batroun_1.jpg",
        "/images/Batroun Mission/batroun_2.jpg",
        "/images/Batroun Mission/batroun_3.jpg",
        "/images/Batroun Mission/batroun_4.jpg"
      ]
    },
    {
      id: 2,
      title: "Afqa Mission",
      location: "Afqa, Mount Lebanon, Lebanon",
      date: "2024",
      description: "Medical outreach mission providing healthcare services to underserved communities in the mountainous Afqa region.",
      impact: "80+ patients treated",
      status: "completed",
      thumbnail: "/images/Afqa Mission/afqa_2.jpg",
      gallery: [
        "/images/Afqa Mission/afqa_1.jpg",
        "/images/Afqa Mission/afqa_2.jpg"
      ]
    },
    {
      id: 3,
      title: "Yammoune Mission",
      location: "Yammoune, Beqaa Governorate, Lebanon",
      date: "2024",
      description: "Delivered comprehensive medical care and health education to the Yammoune community in the Beqaa Valley.",
      impact: "120+ patients treated",
      status: "completed",
      thumbnail: "/images/Yammoune Mission/yammoune_1.jpg",
      gallery: [
        "/images/Yammoune Mission/yammoune_1.jpg"
      ],
      video: "/images/Yammoune Mission/yammoune_video_1.mp4"
    },
    {
      id: 4,
      title: "Syrian Border Mission",
      location: "Syrian Border, Lebanon",
      date: "2025",
      description: "Provided critical medical assistance to refugees and displaced families near the Syrian border.",
      impact: "150+ patients treated",
      status: "completed",
      thumbnail: "/images/Syrian Border Mission/syrian_border_1.jpg",
      gallery: [
        "/images/Syrian Border Mission/syrian_border_1.jpg",
        "/images/Syrian Border Mission/syrian_border_2.jpg",
        "/images/Syrian Border Mission/syrian_border_3.jpg",
        "/images/Syrian Border Mission/syrian_border_4.jpg",
        "/images/Syrian Border Mission/syrian_border_5.jpg"
      ]
    },
    {
      id: 5,
      title: "Tanzania Mission",
      location: "Tanzania",
      date: "2025",
      description: "Comprehensive surgical and medical mission in Tanzania, including community health outreach and surgical interventions.",
      impact: "200+ patients treated",
      status: "completed",
      thumbnail: "/images/Tanzania Mission/tanzania_1.jpg",
      gallery: [
        "/images/Tanzania Mission/tanzania_1.jpg",
        "/images/Tanzania Mission/tanzania_2.jpg",
        "/images/Tanzania Mission/tanzania_3.jpg",
        "/images/Tanzania Mission/tanzania_4.jpg",
        "/images/Tanzania Mission/tanzania_5.jpg",
        "/images/Tanzania Mission/tanzania_6.jpg",
        "/images/Tanzania Mission/tanzania_7.jpg",
        "/images/Tanzania Mission/tanzania_8.jpg",
        "/images/Tanzania Mission/tanzania_9.jpg"
      ]
    },
    {
      id: 6,
      title: "Lebanon Christmas Mission",
      location: "Lebanon",
      date: "December 2025",
      description: "Free medical consultations, medicine distribution, and community health workshops during the Christmas season.",
      impact: "Expected: 300+ patients",
      status: "upcoming",
      thumbnail: "/images/Batroun Mission/batroun_1.jpg",
      gallery: []
    },
    {
      id: 7,
      title: "East Africa Expansion",
      location: "East Africa",
      date: "2026",
      description: "Expanding care to underserved regions in East Africa with mobile clinics and surgical interventions.",
      impact: "Planning phase",
      status: "upcoming",
      thumbnail: "/images/Tanzania Mission/tanzania_1.jpg",
      gallery: []
    }
  ],
  
  impactStats: [
    { icon: "Users", value: "650+", label: "Patients Treated" },
    { icon: "MapPin", value: "5", label: "Missions Completed" },
    { icon: "Heart", value: "100%", label: "Donations to Care" },
    { icon: "Globe", value: "2", label: "Countries Served" }
  ],
  
  contact: {
    email: "info@medicsonmission.org",
    whatsapp: "+49 XXX XXXXXXX",
    instagram: "@medics_on_mission",
    instagramUrl: "https://www.instagram.com/medics_on_mission"
  },
  
  donation: {
    gofundme: "https://www.gofundme.com/f/be-part-of-the-cause",
    transparencyStatement: "100% of your donations go directly to our medical missions. We cover administrative costs through separate funding to ensure every dollar you give makes a direct impact."
  }
};

// Mock form submission handlers
export const mockSubmitVolunteer = (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Volunteer registration submitted:', data);
      resolve({ success: true, message: 'Thank you for your interest! We will contact you soon.' });
    }, 1000);
  });
};

export const mockSubmitContact = (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Contact form submitted:', data);
      resolve({ success: true, message: 'Thank you for reaching out! We will get back to you shortly.' });
    }, 1000);
  });
};

export const mockSubmitDonation = (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Donation submitted:', data);
      resolve({ success: true, message: 'Thank you for your generous donation!' });
    }, 1000);
  });
};